import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { AuthResult, User } from "@/types/auth";
import type { PlanTier } from "@/types/plan";

interface AuthState {
  user: User | null;
  accessToken: string | null;
  expiresAt: string | null;
  planTier: PlanTier | null;
  trialEndsAt: string | null;
  setSession: (result: AuthResult) => void;
  setUser: (user: User) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      accessToken: null,
      expiresAt: null,
      planTier: null,
      trialEndsAt: null,
      setSession: (result) =>
        set({
          user: result.user,
          accessToken: result.accessToken,
          expiresAt: result.expiresAt,
          planTier: result.planTier,
          trialEndsAt: result.trialEndsAt,
        }),
      setUser: (user) => set({ user }),
      logout: () =>
        set({
          user: null,
          accessToken: null,
          expiresAt: null,
          planTier: null,
          trialEndsAt: null,
        }),
    }),
    { name: "ustorio-auth" }
  )
);
